import { parsePhoneNumber } from 'awesome-phonenumber';
export var formatPhoneNumber = function (_a) {
    var phoneNumber = _a.phoneNumber, countryCode = _a.countryCode, _b = _a.format, format = _b === void 0 ? PhoneNumberType.E164 : _b;
    var pn = parsePhoneNumber(phoneNumber, { regionCode: countryCode });
    if (!pn.valid) {
        return { isValid: false, phoneNumber: phoneNumber };
    }
    return {
        isValid: pn.valid,
        phoneNumber: pn.number[format],
    };
};
export var PhoneNumberType;
(function (PhoneNumberType) {
    PhoneNumberType["E164"] = "e164";
    PhoneNumberType["INTERNATIONAL"] = "international";
    PhoneNumberType["NATIONAL"] = "national";
    PhoneNumberType["RFC3966"] = "rfc3966";
    PhoneNumberType["SIGNIFICANT"] = "significant";
})(PhoneNumberType || (PhoneNumberType = {}));
